import type { ReactNode } from 'react';
import { Button } from './Button';
import { Modal } from './Modal';

export interface ConfirmDialogProps {
  open: boolean;
  title: string;
  /** Rečenica koja imenuje što se točno briše ili pokreće — nikad samo „Jesi li sigurna?". */
  question: string;
  confirmLabel: string;
  cancelLabel: string;
  closeLabel: string;
  onConfirm: () => void;
  onClose: () => void;
  tone?: 'danger' | 'neutral';
  loading?: boolean;
  /** Dodatni sadržaj: iznos, email kupca, interna bilješka. */
  children?: ReactNode;
}

/**
 * Nepovratne radnje (brisanje, povrat) uvijek prolaze kroz ovaj dijalog.
 * Potvrdni gumb nikad nije prvi u fokusu — panel dobiva fokus, ne akcija.
 */
export function ConfirmDialog({
  open,
  title,
  question,
  confirmLabel,
  cancelLabel,
  closeLabel,
  onConfirm,
  onClose,
  tone = 'danger',
  loading = false,
  children,
}: ConfirmDialogProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      closeLabel={closeLabel}
      footer={
        <>
          <Button variant="secondary" size="sm" onClick={onClose} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button
            size="sm"
            loading={loading}
            onClick={onConfirm}
            className={tone === 'danger' ? 'bg-danger hover:bg-danger' : undefined}
          >
            {confirmLabel}
          </Button>
        </>
      }
    >
      <p className="text-[14.5px] leading-relaxed text-ink">{question}</p>
      {children && <div className="mt-4 flex flex-col gap-4">{children}</div>}
    </Modal>
  );
}
